import { useNavigate, useSearchParams } from "react-router-dom";

import { LoginTokenLink } from "../../components";
import { appendReturnTo } from "../../utils";

import { LoginInterstitialTemplate } from "./login-interstitial.template";

export const LoginInterstitial = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const username = searchParams.get("username");
	const redirect = searchParams.get("redirect");
	const returnTo = searchParams.get("returnTo");

	const handleSsoClicked = () => {
		if (!redirect) {
			return;
		}

		window.location.replace(appendReturnTo(redirect, returnTo));
	};

	const handlePasswordClicked = () => {
		navigate(appendReturnTo(`/login-password?username=${username || ""}`, returnTo));
	};

	return (
		<>
			<LoginInterstitialTemplate onSsoClicked={handleSsoClicked} onPasswordClicked={handlePasswordClicked} />
			<LoginTokenLink />
		</>
	);
};
